import React, { Component } from "react";
import "./Info.scss";

export default class Info extends Component {
    render() {
        // const sub = this.props.sub ? <sub>{this.props.sub}</sub> : undefined;
        return (
            <div>
                <h5>{this.props.title}: <span className="bookmarks-counter">{this.props.data}</span> &nbsp; | &nbsp;
                {this.props.title2}: <span className="bookmarks-counter">{this.props.data2}</span>
                </h5>
                
            </div>
        );
    }
}
